<template>
  <a-drawer
    :title="title"
    :maskClosable="true"
    :width="drawerWidth"
    placement="right"
    :closable="true"
    @close="handleCancel"
    :visible="visible"
    style=" overflow: auto;padding-bottom: 53px;"
  >
    <template slot="title">
      <div style="width: 100%;">
        <span>{{ title }}</span>
        <span
          style="display:inline-block;width:calc(100% - 51px);padding-right:10px;text-align: right"
        >
          <a-button
            @click="toggleScreen"
            icon="appstore"
            style="height:20px;width:20px;border:0px"
          ></a-button>
        </span>
      </div>
    </template>

    <a-form :form="form">
      <div style="font-size:20px;font-weight:500;">客户标签</div>
      <a-form-item
        label="客户类型"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-select v-model="form.region">
          <a-select-option value="shanghai">
            企业微信客户
          </a-select-option>
          <a-select-option value="beijing">
            微信客户
          </a-select-option>
        </a-select>
        <!-- <a-input v-model="view.grade" :readOnly="view.grade!=null"/> -->
      </a-form-item>

      <a-form-item
        label="客户等级"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-select v-model="form.dengji">
          <a-select-option value="shanghai">
            一般
          </a-select-option>
          <a-select-option value="beijing">
            重要
          </a-select-option>
          <a-select-option value="beijing">
            核心
          </a-select-option>
        </a-select>
        <!-- <a-input v-model="view.hobby" :readOnly="view.hobby!=null"/> -->
      </a-form-item>

      <a-form-item label="标签组" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-select v-model="form.biaoqian">
          <a-select-option value="shanghai">
            标签组1
          </a-select-option>
          <a-select-option value="beijing">
            标签组2
          </a-select-option>
        </a-select>
        <!-- <a-input v-model="view.other" :readOnly="view.other!=null"/> -->
      </a-form-item>

      <customer-window ref="customerWindow" @ok="modalOk"></customer-window>

      <!-- <a-button @click="selectLabel" type="primary" :loading="confirmLoading">选择</a-button> -->
    </a-form>

    <div class="drawer-bootom-button" v-show="!disableSubmit">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: .8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleSubmit()" type="primary" :loading="confirmLoading"
        >提交</a-button
      >
    </div>
  </a-drawer>
</template>

<script>
import Vue from 'vue';
// 引入搜索部门弹出框的组件
import JSelectPosition from '@/components/jeecgbiz/JSelectPosition';
import { ACCESS_TOKEN } from '@/store/mutation-types';
import { disabledAuthFilter } from '@/utils/authFilter';
import JImageUpload from '../../../components/jeecg/JImageUpload';
import { editByUser, emptyLabel, addLabel } from '@/api/api';
import customerWindow from './TagWindow';
import user from '../../../store/modules/user';

export default {
  name: 'LabelModal',
  components: {
    JImageUpload,
    JSelectPosition,
    customerWindow
  },
  data() {
    return {
      view: {
        userid: '',
        external_userid: '',
        grade: '',
        hobby: '',
        other: ''
      },
      departIdShow: false,
      departIds: [], //负责部门id
      title: '操作',
      visible: false,
      model: {},
      roleList: [],
      selectedRole: [],
      selectedRowKeys: [],
      userInfo: [],
      departList: [], // 存储部门信息
      flag: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      status: '',
      uploadLoading: false,
      confirmLoading: false,
      headers: {},
      form: this.$form.createForm(this),
      departDisabled: false, //是否是我的部门调用该页面
      roleDisabled: false, //是否是角色维护调用该页面
      modalWidth: 800,
      drawerWidth: 700,
      modaltoggleFlag: true,
      confirmDirty: false,
      selectedDepartKeys: [], //保存用户选择部门id
      checkedDepartKeys: [],
      checkedDepartNames: [], // 保存部门的名称 =>title
      checkedDepartNameString: '', // 保存部门的名称 =>title
      resultDepartOptions: [],
      userId: '', //保存用户id
      disableSubmit: false,
      userDepartModel: { userId: '', departIdList: [] }, // 保存SysUserDepart的用户部门中间表数据需要的对象
      dateFormat: 'YYYY-MM-DD'
    };
  },

  created() {
    const token = Vue.ls.get(ACCESS_TOKEN);
    this.headers = { 'X-Access-Token': token };
  },
  // inject: ['reload'],
  methods: {
    selectLabel() {
      this.$refs.customerWindow.add('6', this.selectedRowKeys);
    },
    isDisabledAuth(code) {
      return disabledAuthFilter(code);
    },
    // inject: ['reload'],
    //窗口最大化切换
    toggleScreen() {
      if (this.modaltoggleFlag) {
        this.modalWidth = window.innerWidth;
      } else {
        this.modalWidth = 800;
      }
      this.modaltoggleFlag = !this.modaltoggleFlag;
    },

    add(data, records) {
      this.edit(data, records);
    },
    edit(data, records) {
      this.userInfo = records;
      this.view.userid = records.userid;
      this.view.external_userid = records.external_contact.external_userid;
      this.view.hobby = records.hobby;
      this.view.other = records.other;
      this.view.grade = records.grade;
      this.resetScreenSize(); // 调用此方法,根据屏幕宽度自适应调整抽屉的宽度
      let that = this;
      that.visible = true;
    },
    handleSubmit() {
      //先清空
      let formData = {};
      emptyLabel(formData).then(res => {
        if (res.success) {
          var list = this.departList;
          var add_tag = [];
          for (var i = 0; i < list.length; i++) {
            add_tag.push(list[i].key);
          }
          var userInfo = [];
          userInfo.push(this.userInfo);
          let formData1 = {
            user: userInfo,
            add_tag: add_tag
          };
          addLabel(formData1).then(res => {
            if (res.success) {
              this.$message.success(res.result);
            } else {
              this.$message.success(res.result + '请检查是否依次进行添加');
            }
            // this.reload()
            this.$emit('searchReset');
            this.close();
          });
        } else {
          this.$message.success(res.result);
        }
      });
      //在添加
    },
    handleCancel() {
      this.visible = false;
      this.close();
    },
    close() {
      this.$emit('close');
      this.visible = false;
      this.disableSubmit = false;
      this.selectedRole = [];
      this.userDepartModel = { userId: '', departIdList: [] };
      this.checkedDepartNames = [];
      this.checkedDepartNameString = '';
      this.checkedDepartKeys = [];
      this.selectedDepartKeys = [];
      this.resultDepartOptions = [];
      this.departIds = [];
      this.departIdShow = false;
      this.identity = '1';
      this.avatar_mediaid = [];
    },
    modalOk(formData) {
      this.checkedDepartNames = [];
      this.selectedDepartKeys = [];
      this.checkedDepartNameString = '';
      this.departIds = [];
      this.resultDepartOptions = [];
      this.view.hobbyArr = [];
      this.view.gradeArr = [];
      this.view.otherArr = [];
      this.departList = formData.departIdList;
      var depart = [];
      for (var i = 0; i < formData.departIdList.length; i++) {
        if (
          formData.departIdList[i].parentName ===
          'etzEEaDAAAK0oTiZsSc-5ifkk1K6F8hQ'
        ) {
          this.view.hobbyArr.push(formData.departIdList[i].title);
          this.view.hobby = this.view.hobbyArr.join(',');
        } else if (
          formData.departIdList[i].parentName ===
          'etzEEaDAAAVdKG-GpyDYVz1oBPw2D-Pg'
        ) {
          this.view.gradeArr.push(formData.departIdList[i].title);
          this.view.grade = this.view.gradeArr.join(',');
        } else {
          this.view.otherArr.push(formData.departIdList[i].title);
          this.view.other = this.view.otherArr.join(',');
        }
        this.departIds.push(formData.departIdList[i].key);
      }
      this.resultDepartOptions = depart;
      this.userDepartModel.departIdList = this.selectedDepartKeys;
      this.checkedDepartKeys = this.selectedDepartKeys; //更新当前的选择keys
    },
    // 根据屏幕变化,设置抽屉尺寸
    resetScreenSize() {
      let screenWidth = document.body.clientWidth;
      if (screenWidth < 500) {
        this.drawerWidth = screenWidth;
      } else {
        this.drawerWidth = 700;
      }
    }
  }
};
</script>

<style scoped>
.avatar-uploader > .ant-upload {
  width: 104px;
  height: 104px;
}

.ant-upload-select-picture-card i {
  font-size: 49px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.ant-table-tbody .ant-table-row td {
  padding-top: 10px;
  padding-bottom: 10px;
}

.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
